import React, { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { IfHasPermissionProps } from './IfHasPermission.type';

const PERMISSION_DENIED_MESSAGE = "You don't have permission to perform this action";

export const IfHasPermission: React.FC<IfHasPermissionProps> = ({
  permissions = [],
  requires,
  mode = 'any',
  children,
  fallback = null,
  showDisabled = false,
  allowAdmin = false,
}) => {
  const requiredPermissions = Array.isArray(requires) ? requires : [requires];

  // useContext, not useAuth: useAuth throws when the provider is missing, and
  // this component renders in twenty places. A gate that crashes the tree it
  // is protecting is worse than one that assumes the user is not an admin.
  const hasAdminRole = useContext(AuthContext)?.hasAdminRole ?? false;

  const hasPermission =
    (allowAdmin && hasAdminRole) ||
    (mode === 'all'
      ? requiredPermissions.every(perm => permissions.includes(perm))
      : requiredPermissions.some(perm => permissions.includes(perm)));

  if (!hasPermission && showDisabled) {
    return (
      <>
        {React.Children.map(children, child => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              disabled: true,
              title: PERMISSION_DENIED_MESSAGE,
              ...child.props,
            } as any);
          }
          return child;
        })}
      </>
    );
  }

  if (!hasPermission) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};